import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notification, Switch } from "antd";
import { Field } from "formik";

import { Button, Fields } from "components";
import { useGet, useHooks } from "hooks";
import Container from "modules/container";
import { utils } from "services";
import { langlist } from "services/helpers";

const CreateVacancy = () => {
  const [selectedLang, setSelectedLang] = useState("O'z");
  const navigate = useNavigate();

  const { get, t, params } = useHooks();
  const { id }: any = params;

  const { data: vacancyData } = useGet({
    name: "vacancy",
    url: `/vacancy/${id}`,
    onSuccess: () => {},
    onError: () => {},
    enabled: !!id,
  });

  const data = get(vacancyData, "data");
  return (
    <div>
      <Container.Form
        url={data ? `/vacancy/${id}` : "/vacancy"}
        name="vacancy"
        method={data ? "put" : "post"}
        fields={[
          {
            type: "string",
            name: "titleUz",
            value: get(data, "titleUz"),
            required: true
          },
          {
            type: "string",
            name: "titleRu",
            value: get(data, "titleRu"),
            required: true
          },
          {
            type: "string",
            name: "titleEn",
            value: get(data, "titleEn"),
            required: true
          },
          {
            type: "string",
            name: "descriptionUz",
            value: get(data, "descriptionUz"),
            required: true
          },
          {
            type: "string",
            name: "descriptionRu",
            value: get(data, "descriptionRu"),
            required: true
          },
          {
            type: "string",
            name: "descriptionEn",
            value: get(data, "descriptionEn"),
            required: true
          },

        ]}
        onSuccess={(data, resetForm) => {
          notification.success({
            message: t("Muvaffaqiyatli"),
            duration: 2,
          });
          resetForm();
          navigate("/vacancy");
        }}
        onError={(error) => {
          notification.error({
            message: get(error, "errorMessage", t("Something went wrong!")),
            duration: 2,
          });
        }}
      >
        {({ values, setFieldValue, submitForm }) => {
          return (
            <div className="form-wrapper">
              <div className="w-full">
                <div className="">
                  {/* <div className="flex justify-between mb-[30px]">
                    <div className="content-panel w-full">
                      <p className="content-panel-title mb-[20px]">
                        {t("Vakansiya rasmi")}
                      </p>
                      <Field
                        name={`images`}
                        component={Fields.FileUpload}
                        placeholder={t("Rasm joylash")}
                        className="mb-[10px] object-fill"
                        multiple
                        maxFiles="3"
                      />
                    </div>
                  </div> */}
                  <div className="content-panel">
                    <p className="content-panel-title mb-[20px]">
                      {t("Vakansiya tavsifi")}
                    </p>
                    <div className="lang-tabs">
                      {langlist.map((item) => (
                        <div
                          className={
                            selectedLang === item.shortName
                              ? "lang-tabs__tab--selected"
                              : "lang-tabs__tab"
                          }
                          key={get(item, "id")}
                          onClick={() => setSelectedLang(item.shortName)}
                        >
                          <p className="lang-tabs__tab__title">
                            {get(item, "title")}
                          </p>
                        </div>
                      ))}
                      <div className="lang-tabs__last"></div>
                    </div>
                    <div className="w-full">
                      {selectedLang == "O'z" && (
                        <Field
                          type="text"
                          name="titleUz"
                          label={t("Vakansiya (uz)")}
                          component={Fields.Input}
                          placeholder={t("Vakansiya nomini (uz) kiriting")}
                        />
                      )}
                      {selectedLang == "Ру" && (
                        <Field
                          type="text"
                          name="titleRu"
                          label={t("Vakansiya (ru)")}
                          component={Fields.Input}
                          placeholder={t("Vakansiya nomini (ru) kiriting")}
                        />
                      )}
                      {selectedLang == "En" && (
                        <Field
                          type="text"
                          name="titleEn"
                          label={t("Vakansiya (en)")}
                          component={Fields.Input}
                          placeholder={t("Vakansiya nomini (en) kiriting")}
                        />
                      )}
                    </div>
                    <div className="w-full mt-[20px]">
                      {selectedLang == "O'z" && (
                        <Field
                          component={Fields.Ckeditor}
                          className="h-[30vh] "
                          type="text"
                          name="descriptionUz"
                          label={t("Vakansiya haqida (uz)")}
                          placeholder={t("Vakansiya haqida (uz) kiriting")}
                        />
                      )}
                      {selectedLang == "Ру" && (
                        <Field
                          component={Fields.Ckeditor}
                          className="h-[30vh] "
                          type="text"
                          name="descriptionRu"
                          label={t("Vakansiya haqida (ru)")}
                          placeholder={t("Vakansiya haqida (ru) kiriting")}
                        />
                      )}
                      {selectedLang == "En" && (
                        <Field
                          component={Fields.Ckeditor}
                          className="h-[30vh] "
                          type="text"
                          name="descriptionEn"
                          label={t("Vakansiya haqida (en)")}
                          placeholder={t("Vakansiya haqida (en) kiriting")}
                        />
                      )}
                    </div>
                  </div>
                <Button
                  type="default"
                  title={t("Bekor qilish")}
                  className="w-full mt-[20px] bg-[#fff]"
                  onClick={() => navigate("/vacancy")}
                />
                <Button
                  type="primary"
                  className="w-full mt-[20px]"
                  onClick={() => submitForm()}
                  title={
                    get(vacancyData, "data") ? t("Saqlash") : t("Tasdiqlash")
                  }
                />
             
                </div>
              </div>
                
              </div>
          );
        }}
      </Container.Form>
    </div>
  );
};

export default CreateVacancy;
